/* IONARA THEME JS — v9 final */
document.addEventListener('DOMContentLoaded', () => {

  /* ---- Mobile menu ---- */
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
      const spans = menuBtn.querySelectorAll('span');
      if (open) {
        spans[0].style.cssText = 'transform:rotate(45deg) translate(5px,5px)';
        spans[1].style.cssText = 'opacity:0';
        spans[2].style.cssText = 'transform:rotate(-45deg) translate(5px,-5px)';
      } else {
        spans.forEach(s => s.style.cssText = '');
      }
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.querySelectorAll('span').forEach(s => s.style.cssText = '');
      });
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ---- Quantity controls ---- */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const control = btn.closest('.qty-control');
      const input = control.querySelector('.qty-input');
      let v = parseInt(input.value) || 1;
      if (btn.dataset.action === 'plus') v = Math.min(v + 1, 99);
      if (btn.dataset.action === 'minus') v = Math.max(v - 1, 1);
      input.value = v;
    });
  });

  /* ---- Scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    const style = document.createElement('style');
    style.textContent = '[data-reveal]{opacity:0;transform:translateY(20px);transition:opacity .6s ease,transform .6s ease}[data-reveal].revealed{opacity:1;transform:none}';
    document.head.appendChild(style);
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('revealed'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
  }

  /* ---- Stat bar fill animation ---- */
  const statBars = document.querySelectorAll('.pdp-stat-bar-fill');
  if (statBars.length && 'IntersectionObserver' in window) {
    statBars.forEach(bar => { bar.dataset.targetWidth = bar.style.width; bar.style.width = '0'; });
    const barIo = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.style.width = e.target.dataset.targetWidth; barIo.unobserve(e.target); }});
    }, { threshold: 0.3 });
    statBars.forEach(bar => barIo.observe(bar));
  }

  /* ---- Sticky header ---- */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 60), { passive: true });
  }

  /* ---- Smooth anchor scroll ---- */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (target) { e.preventDefault(); window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' }); }
    });
  });

  /* ====================================================
     CART HELPERS
     ==================================================== */

  function updateCartBadge(count) {
    let badge = document.querySelector('.cart-badge');
    const cartLink = document.querySelector('.header-icon-link[aria-label="Cart"]');
    if (!cartLink) return;
    if (count > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'cart-badge'; cartLink.appendChild(badge); }
      badge.textContent = count;
    } else {
      if (badge) badge.remove();
    }
  }

  function refreshCartCount() {
    fetch('/cart.js').then(r => r.json()).then(cart => updateCartBadge(cart.item_count)).catch(() => {});
  }

  function ajaxAddToCart(variantId, qty, onSuccess, onError) {
    // Clean the variant ID — trim whitespace, ensure it's a real number
    const vid = String(variantId || '').trim();
    if (!vid || isNaN(parseInt(vid))) { onError('no-variant'); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(vid), quantity: qty || 1 })
    })
    .then(r => r.json())
    .then(data => {
      if (data.status && data.status !== 200) { onError(data.description || 'Could not add to cart.'); }
      else { refreshCartCount(); onSuccess(); }
    })
    .catch(() => onError('Network error — please try again.'));
  }

  /* ====================================================
     HOMEPAGE PRODUCT FEATURE — Add to Cart (AJAX) & Buy Now
     ==================================================== */
  const hpAtcBtn = document.getElementById('hp-atc-btn');
  const hpBuyNow = document.getElementById('hp-buynow-btn');
  const hpQty   = document.getElementById('hp-qty');
  const hpFeedback = document.getElementById('hp-atc-feedback');

  if (hpAtcBtn) {
    hpAtcBtn.addEventListener('click', () => {
      const variantId = hpAtcBtn.dataset.variant;
      const qty = parseInt(hpQty?.value) || 1;
      const original = hpAtcBtn.textContent;

      hpAtcBtn.textContent = 'Adding…';
      hpAtcBtn.disabled = true;

      ajaxAddToCart(variantId, qty,
        () => { // success — stay on page, show feedback
          hpAtcBtn.textContent = '✓ Added to cart!';
          hpAtcBtn.style.background = '#3a7d0a';
          hpAtcBtn.style.borderColor = '#3a7d0a';
          if (hpFeedback) { hpFeedback.style.display = 'block'; setTimeout(() => hpFeedback.style.display = 'none', 3000); }
          setTimeout(() => {
            hpAtcBtn.textContent = original;
            hpAtcBtn.style.background = '';
            hpAtcBtn.style.borderColor = '';
            hpAtcBtn.disabled = false;
          }, 2500);
        },
        (err) => { // error
          if (err === 'no-variant') {
            // Product not wired up in theme editor — send to product page
            window.location = '/products/ionara-advanced-hydration-electrolytes-electric-lime-24-sachets';
          } else {
            hpAtcBtn.textContent = original;
            hpAtcBtn.disabled = false;
            console.warn('ATC error:', err);
          }
        }
      );
    });
  }

  if (hpBuyNow) {
    hpBuyNow.addEventListener('click', () => {
      const variantId = hpBuyNow.dataset.variant;
      const qty = parseInt(hpQty?.value) || 1;
      hpBuyNow.textContent = 'Adding…';
      hpBuyNow.disabled = true;
      ajaxAddToCart(variantId, qty,
        () => { window.location = '/cart'; },
        (err) => {
          if (err === 'no-variant') { window.location = '/products/ionara-advanced-hydration-electrolytes-electric-lime-24-sachets'; }
          else { hpBuyNow.textContent = 'Buy Now'; hpBuyNow.disabled = false; }
        }
      );
    });
  }

  /* ====================================================
     PRODUCT PAGE — Add to Cart (AJAX, no redirect)
     Buy Now handled by native form submit → stays on product page
     then we redirect to /cart manually
     ==================================================== */
  const pdpForm = document.getElementById('product-form');
  const pdpAtcBtn = pdpForm?.querySelector('[name="add"]');
  const pdpBuyNow = document.getElementById('buy-now-btn');

  if (pdpAtcBtn && pdpForm) {
    pdpAtcBtn.addEventListener('click', e => {
      e.preventDefault();
      const variantId = pdpForm.querySelector('[name="id"]')?.value;
      const qty = parseInt(pdpForm.querySelector('[name="quantity"]')?.value) || 1;
      const original = pdpAtcBtn.textContent;

      pdpAtcBtn.textContent = 'Adding…';
      pdpAtcBtn.disabled = true;

      ajaxAddToCart(variantId, qty,
        () => {
          pdpAtcBtn.textContent = '✓ Added!';
          pdpAtcBtn.style.background = '#3a7d0a';
          pdpAtcBtn.style.borderColor = '#3a7d0a';
          // Update sticky bar too
          const stickyBtn = document.getElementById('sticky-add-btn');
          if (stickyBtn) { stickyBtn.textContent = '✓ Added!'; setTimeout(() => stickyBtn.textContent = 'Add to Cart', 2500); }
          setTimeout(() => {
            pdpAtcBtn.textContent = original;
            pdpAtcBtn.style.background = '';
            pdpAtcBtn.style.borderColor = '';
            pdpAtcBtn.disabled = false;
          }, 2500);
        },
        () => { pdpAtcBtn.textContent = original; pdpAtcBtn.disabled = false; }
      );
    });
  }

  if (pdpBuyNow) {
    pdpBuyNow.addEventListener('click', () => {
      const variantId = pdpForm?.querySelector('[name="id"]')?.value;
      const qty = parseInt(pdpForm?.querySelector('[name="quantity"]')?.value) || 1;
      pdpBuyNow.textContent = 'Adding…';
      pdpBuyNow.disabled = true;
      ajaxAddToCart(variantId, qty,
        () => { window.location = '/cart'; },
        () => { pdpBuyNow.textContent = 'Buy Now'; pdpBuyNow.disabled = false; }
      );
    });
  }

  /* ====================================================
     STICKY BAR — Add to Cart on product page
     ==================================================== */
  const stickyBar = document.getElementById('sticky-atc-bar');
  const stickyAddBtn = document.getElementById('sticky-add-btn');
  const purchaseBlock = document.querySelector('.purchase-block');

  if (stickyBar && purchaseBlock) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        stickyBar.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(purchaseBlock);
  }

  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', () => {
      const variantId = pdpForm?.querySelector('[name="id"]')?.value;
      stickyAddBtn.textContent = 'Adding…';
      stickyAddBtn.disabled = true;
      ajaxAddToCart(variantId, 1,
        () => { stickyAddBtn.textContent = '✓ Added!'; stickyAddBtn.disabled = false; setTimeout(() => stickyAddBtn.textContent = 'Add to Cart', 2500); },
        () => { stickyAddBtn.textContent = 'Add to Cart'; stickyAddBtn.disabled = false; }
      );
    });
  }

  /* ====================================================
     CART PAGE — auto-update on qty change, allow 0 to remove
     ==================================================== */
  const cartForm = document.querySelector('form[action="/cart"]');
  if (cartForm) {
    // Auto-update when qty input changes (no manual click needed)
    const savingIndicator = document.getElementById('cart-saving');
    cartForm.querySelectorAll('.qty-input').forEach(input => {
      let debounceTimer;
      input.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        if (savingIndicator) savingIndicator.style.opacity = '1';
        debounceTimer = setTimeout(() => {
          const key = input.closest('tr')?.querySelector('[name^="updates["]')?.name?.match(/updates\[(.+)\]/)?.[1]
                   || input.name?.match(/updates\[(.+)\]/)?.[1];
          if (!key) return;

          const newQty = parseInt(input.value);
          if (isNaN(newQty) || newQty < 0) return;

          // qty = 0 removes the item
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          })
          .then(r => r.json())
          .then(cart => {
            updateCartBadge(cart.item_count);
            // Reload to reflect the updated totals and removed items
            window.location.reload();
          })
          .catch(() => {});
        }, 600);
      });
    });

    // Qty +/- on cart page also auto-saves
    cartForm.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const control = btn.closest('.qty-control');
        const input = control.querySelector('.qty-input');
        let v = parseInt(input.value) || 0;
        if (btn.dataset.action === 'plus') v = Math.min(v + 1, 99);
        if (btn.dataset.action === 'minus') v = Math.max(v - 1, 0); // allow 0 to remove
        input.value = v;
        input.dispatchEvent(new Event('input')); // trigger auto-save
      });
    });
  }

});
